import React from 'react';
import { CheckIcon, DumbbellIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { bonuses, faqs, features, heroIncludes, offerChecklist, outcomes, painPoints, testimonials, volumeTitles } from '../data/content';
const EBOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/9oM8AZYNwKDXoVFM3XGYGm/Mockup_TPTS.png';
const phases = [{
  label: 'Build',
  description: '12-week hypertrophy and strength phases already periodized.'
}, {
  label: 'Lean',
  description: 'Fat loss protocols that protect muscle and stop the yo-yo.'
}, {
  label: 'Perform',
  description: 'Power, speed, and capacity work for premium athletic clients.'
}, {
  label: 'Coach',
  description: '150+ exercises with cues, mistakes, and print-ready sheets.'
}, {
  label: 'Track',
  description: 'Logs and dashboards that turn progress into visible proof.'
}, {
  label: 'Protect',
  description: 'Mobility, screening, and recovery so clients train for decades.'
}];
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-cream font-body text-slate-800" data-id="element-10" data-mp="35sqbdj8blh2q">

      {/* Top banner */}
      <header data-id="element-11" data-mp="30uoqqtv8x9p5">
        <div className="bg-brand-medium px-4 py-2 text-center text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-12" data-mp="30u6nhda61v7q">
          <span aria-hidden="true" data-id="element-13" data-mp="2vszgvhjrf22n">⚡ </span>Digital download — Instant access after purchase
        </div>
        
      </header>

      <main id="top" data-id="element-14" data-mp="3oizqftp7h3bu">

        {/* Hero */}
        <section className="bg-brand-deep px-5 py-8 text-center text-white sm:py-14 lg:py-16" data-id="element-15" data-mp="3okaqpjjfzsy7">
          <div className="mx-auto max-w-4xl" data-id="element-16" data-mp="3jitui1bwkuny">
            <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-7xl" data-id="element-17" data-mp="3fj33bwigsciw">
              Stop Wasting 50+ Hours a Month Planning Workouts{' '}
              <span className="text-brand-gold" data-id="element-18" data-mp="243nx024d88b4">You&apos;ll Never Use</span>
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/85 sm:mt-4 sm:text-xl" data-id="element-19" data-mp="2460nj3o6vqzs">
              The complete{' '}
              <strong className="font-black text-white" data-id="element-20" data-mp="2ak66oo18gg6x">6-volume system</strong> that eliminates guesswork, scales your business, and guarantees results — without ever starting from scratch again.
            </p>
            <img src={EBOOK_COVER_URL} alt="The Personal Trainer System — the complete 6-volume system plus 5 bonuses included" className="mx-auto mt-3 w-full max-w-[280px] bg-transparent object-contain sm:mt-5 sm:max-w-md lg:max-w-lg" data-id="element-21" data-mp="20kfe4rw8gb9h" />
            <div className="mt-4 sm:mt-6" data-id="element-22" data-mp="1rmvaxdet84w8">
              <CtaButton label="YES, I WANT THE SYSTEM!" data-id="element-23" data-mp="1cwxigl9ukt18" />
              <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-24" data-mp="1cubbonus6hk2">
                Secure checkout in your local currency
              </p>
            </div>

            {/* What you get */}
            <div className="mx-auto mt-8 max-w-2xl text-left sm:mt-10" data-id="element-25" data-mp="17x1oleuv6hze">
              <p className="text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-26" data-mp="17w9r1yhpia6h">
                Here is everything you get
              </p>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" role="list" data-id="element-27" data-mp="kapp8vnj7722">
                {heroIncludes.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-28" data-mp="yai9q98gsr1l">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-gold" aria-hidden="true" data-id="element-29" data-mp="t91bklhd7iop" />
                    <span className="text-[15px] leading-snug text-white/90" data-id="element-30" data-mp="185sg195wbkl6">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-7 text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-31" data-mp="1gzx8fx0oh42t">
                The 6 volumes inside
              </p>
              <ul className="mt-4 space-y-2" role="list" data-id="element-32" data-mp="1cz4zz5zmr37l">
                {volumeTitles.map(volume => <li key={volume} className="flex items-start gap-3 border-l-2 border-brand-gold/60 pl-4 text-[15px] leading-snug text-white/90" data-id="element-33" data-mp="1qymi52if7i7z">
                    {volume}
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* Social proof bar */}
        <section aria-label="Social proof" className="bg-[#E4DCCC] px-5 py-4 text-center text-sm font-bold sm:text-base text-brand-deep" data-id="element-34" data-mp="2a16icov5fq20">
          <span aria-hidden="true" data-id="element-35" data-mp="2jsjalhkv0i8k">🏋️ </span>Built for Personal Trainers who want to charge like professionals, not improvise every Sunday night
        </section>

        {/* Pain points */}
        <section id="pain-points" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-36" data-mp="1n4mt8ahlliwa">
          <div className="mx-auto max-w-5xl" data-id="element-37" data-mp="1r459uu2dz7tb">
            <div className="mx-auto max-w-2xl text-center" data-id="element-38" data-mp="1w2f85djeqoj5">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-39" data-mp="1w51cl4b04nx5">
                You are not alone
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-40" data-mp="37iwswgdn72py">
                Does any of this sound familiar?
              </h2>
            </div>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" role="list" data-id="element-41" data-mp="10u4mtn2v0wk2">
              {painPoints.map(point => <li key={point.text} className="flex items-start gap-4 rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-42" data-mp="vvtan5p3e9yo">
                  <span className="mt-0.5 text-2xl" aria-hidden="true" data-id="element-43" data-mp="r1yuudclyf4v">{point.emoji}</span>
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-44" data-mp="m4oxmbiz8z6h">{point.text}</span>
                </li>)}
            </ul>
            <blockquote className="mx-auto mt-10 max-w-3xl border-l-4 border-brand-medium pl-5 font-display text-xl font-bold italic leading-relaxed text-brand-deep sm:text-2xl" data-id="element-45" data-mp="d4abj9y6vg1x">
              "You do not have a coaching problem. You are missing the operating system for your business."
            </blockquote>
            <p className="mx-auto mt-5 max-w-3xl text-center text-base leading-relaxed text-slate-600" data-id="element-46" data-mp="22iyopdelt210">
              You went to school for exercise science, not business systems. So every week you rebuild an elite coaching framework from zero — and it is costing you your evenings, your pricing power, and the clients who plateau before they see what you can really do.
            </p>
          </div>
        </section>

        {/* Solution */}
        <section id="solution" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-47" data-mp="3i3r6q1sbph59">
          <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="3n211iba4yfqc">
            <DumbbellIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-49" data-mp="elpgydmwhlqt" />
            <p className="mt-5 text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-50" data-mp="jkag09qf1zdo">The solution</p>
            <h2 className="mt-3 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-51" data-mp="5laqkzv2xggg">
              You don&apos;t need to work more hours. You need a documented system.
            </h2>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-52" data-mp="2qaqpki4gcbh6">
              <p data-id="element-53" data-mp="2ucc0hxxfefoq">
                The Personal Trainer System is not another generic fitness course. It is a 6-volume, 350+ page coaching infrastructure: the periodized programs you no longer have to write, the tracking that proves your work, and the documents that make your business look like a business.
              </p>
              <p data-id="element-54" data-mp="2wq7ci2axy8ff">
                <strong className="font-bold text-white" data-id="element-55" data-mp="2wqqkorashig9">Set it up once</strong> and every future client gets the same elite experience — without you losing another Sunday night to a blank spreadsheet.
              </p>
            </div>
            <div className="mt-8 grid gap-3 text-left sm:grid-cols-2" data-id="element-56" data-mp="2408ma3l0g596">
              {phases.map(phase => <div key={phase.label} className="rounded-xl border border-white/15 bg-white/5 p-4" data-id="element-57" data-mp="1z1ngzpqwivdv">
                  <p className="text-sm font-black uppercase tracking-wide text-brand-gold" data-id="element-58" data-mp="2du7k4qe1x2vb">{phase.label}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/80" data-id="element-59" data-mp="1lc3iwx89mmaw">{phase.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* What's inside */}
        <section id="inside" className="bg-[#EBE4D7] px-5 py-12 sm:py-16" data-id="element-60" data-mp="utntk9uom6uq">
          <div className="mx-auto max-w-6xl" data-id="element-61" data-mp="uvs6fhak6g75">
            <div className="mx-auto max-w-2xl text-center" data-id="element-62" data-mp="zrz1gf1f27ab">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-63" data-mp="zuljx9pui77b">
                Ready-to-deploy templates, no theory
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-64" data-mp="18v07kfqa7ydz">
                The 6 Volumes of the System
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-65" data-mp="1iqbn309il9ms">
              {features.map((feature, index) => <article key={feature.title} className="rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-66" data-mp="1niuzhtwgtyq0" data-mpi={index}>
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-deep font-display text-lg font-bold text-brand-gold" data-id="element-67" data-mp="1sjine6pedzg0">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-68" data-mp="3m0f00phwkox9">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-xs font-black uppercase tracking-wide text-brand-medium" data-id="element-69" data-mp="3h3essb9bhg4k">
                    {feature.pain}
                  </p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-70" data-mp="381f898z3ftwv">
                    {feature.description}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        {/* Bonuses */}
        <section id="bonuses" className="bg-[#F3EEE4] px-5 py-12 sm:py-16" data-id="element-71" data-mp="4m16nq4ozxzw">
          <div className="mx-auto max-w-5xl" data-id="element-72" data-mp="3vwi1dt4xkjj5">
            <div className="mx-auto max-w-2xl text-center" data-id="element-73" data-mp="3qzrlp6x1fpy9">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-74" data-mp="3qx5fpbpspii5">
                Included at no extra cost
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-75" data-mp="ni9gz8ckaz22">
                🎁 5 Premium Bonuses Included
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-76" data-mp="2wfewph88lvhr">
                Everything you need to onboard, convert, and retain premium clients starting this week.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-77" data-mp="36d33x6n14vgt">
              {bonuses.map(bonus => <article key={bonus.title} className="rounded-r-2xl border-l-4 border-brand-medium bg-white px-5 py-5 shadow-sm sm:px-6" data-id="element-78" data-mp="3kcuesyi91vql">
                  <div className="flex items-start gap-4" data-id="element-79" data-mp="3fd80smulkbgq">
                    <span className="text-3xl" aria-hidden="true" data-id="element-80" data-mp="3u2nn9qn3huqm">{bonus.emoji}</span>
                    <div data-id="element-81" data-mp="3p3u8luw2nxov">
                      <span className="inline-block rounded-full bg-brand-gold px-3 py-1 text-xs font-black uppercase tracking-wide text-brand-deep" data-id="element-82" data-mp="3p3kh22vdpih2">
                        {bonus.tag}
                      </span>
                      <h3 className="mt-3 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-83" data-mp="205y7wbzybt5">
                        {bonus.title}
                      </h3>
                      <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-84" data-mp="qjr7063z1f55">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-85" data-mp="2twuxqrh7uly">
          <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="7kvecz7rh8tf">
            <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="7lwzjwihrbov">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-88" data-mp="3p256tq8k2ugt">
                Coaches already using it
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-89" data-mp="3u0zm4i7be0w6">
                What Trainers Are Saying
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-90" data-mp="3kzib3e8rkpec">
              {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-brand-deep/10 bg-white p-6 shadow-sm" data-id="element-91" data-mp="1qle5najqzrho">
                  <blockquote className="text-[15px] leading-relaxed text-slate-700" data-id="element-92" data-mp="1gu01uqkrk5iq">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>
                  <figcaption className="mt-auto pt-5 text-sm font-black uppercase tracking-wide text-brand-medium" data-id="element-93" data-mp="1cu9aolrbrndo">
                    {testimonial.name} · {testimonial.location}
                  </figcaption>
                </figure>)}
            </div>
          </div>
        </section>

        {/* Outcomes */}
        <section id="outcomes" className="bg-[#EBE4D7] px-5 py-12 sm:py-16" data-id="element-94" data-mp="20jtypj2c5att">
          <div className="mx-auto max-w-4xl text-center" data-id="element-95" data-mp="1vimq5hsdc7m3">
            <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-96" data-mp="p33z4isf3h96">
              What you will achieve
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-97" data-mp="k2fyd5edzm1r">
              After the System
            </h2>
            <p className="mx-auto mt-5 max-w-3xl font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-98" data-mp="30pe8omyg7afo">
              "Elite coaches are not reinventing the wheel every Sunday. They have a framework, and they just execute it."
            </p>
            <ul className="mt-8 grid gap-4 text-left sm:grid-cols-2" role="list" data-id="element-99" data-mp="39kc5440t15br">
              {outcomes.map(outcome => <li key={outcome} className="flex items-start gap-3 rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-100" data-mp="3jgotqnhhsszn">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-medium" aria-hidden="true" data-id="element-101" data-mp="3ofi6uesvahza" />
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-102" data-mp="3sgbzflh98kyi">{outcome}</span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Offer */}
        <section id="offer" className="bg-brand-deep px-5 py-12 sm:py-16" data-id="element-103" data-mp="1y2kfnt57okpc">
          <div className="mx-auto max-w-xl rounded-3xl bg-white p-7 text-center shadow-2xl sm:p-8" data-id="element-104" data-mp="12t5qer5pg89i">
            <SparklesIcon className="mx-auto h-9 w-9 text-brand-medium" aria-hidden="true" data-id="element-105" data-mp="yrkgneogwa3j" />
            <h2 className="mt-4 font-display text-3xl font-bold text-brand-deep sm:text-4xl" data-id="element-106" data-mp="1crbr55frz8cs">
              Everything You Get Today
            </h2>
            <p className="mt-2 font-display text-2xl font-bold text-brand-deep sm:text-3xl" data-id="element-107" data-mp="17tk00dmyfq9n">
              The Personal Trainer System
            </p>
            <ul className="mt-7 space-y-3 text-left" role="list" data-id="element-108" data-mp="f3l9sex0xn3e">
              {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-slate-700" data-id="element-109" data-mp="tshbzvceg5w3">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-medium" aria-hidden="true" data-id="element-110" data-mp="p20zcdgekoas" />
                  <span data-id="element-111" data-mp="1bwxobmryymf">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 flex flex-col items-center border-t border-brand-deep/10 pt-7 text-center" data-id="element-112" data-mp="19twqwk33l2x">
              <p className="text-base font-bold text-slate-500 line-through" data-id="element-113" data-mp="280fczf4outlk">99 USD</p>
              <p className="mt-1 font-display text-5xl font-bold leading-none text-brand-deep" data-id="element-114" data-mp="27ym55wica3bz">
                27 <span className="align-middle text-2xl" data-id="element-115" data-mp="2ct058c7y4ymz">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold text-slate-600" data-id="element-116" data-mp="1z1ljhxmnmjc8">
                One-time payment — Lifetime access
              </p>
            </div>
            <p className="mt-6 text-sm font-black text-brand-medium" data-id="element-117" data-mp="2qqoq3k20k5s1">
              Launch offer · Price goes up soon
            </p>
            <CtaButton label="YES, I WANT THE SYSTEM!" className="mt-3 w-full" target="checkout" data-id="element-118" data-mp="2vphtukri0if0" />
            <p className="mt-3 text-xs font-bold tracking-wide text-slate-500" data-id="element-119" data-mp="2hpqikrsd9g4p">
              Secure checkout in your local currency
            </p>
            <p className="mt-2 text-xs font-bold tracking-wide text-slate-500" data-id="element-120" data-mp="16bcxtvswtgsw">
              🔒 Secure checkout <span aria-hidden="true" data-id="element-121" data-mp="1b9wpmcu6pmt6">|</span> 📩 Instant delivery <span aria-hidden="true" data-id="element-122" data-mp="1bbhi7wwxuvoe">|</span> 🛡️ 60-day guarantee
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-123" data-mp="38091uvek25lv">
          <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="382c3kcp2ln6f">
            <div className="text-center" data-id="element-125" data-mp="338r2ucw3ef3j">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-126" data-mp="337pskamwhwmv">
                Clear answers
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-127" data-mp="2u8kq4t87xj5f">
                Frequently Asked Questions
              </h2>
            </div>
            <div className="mt-8 space-y-3" data-id="element-128" data-mp="2kaes4mpj8x5u">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-129" data-mp="2kay9o2b9tjjc" />)}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section id="final-cta" className="bg-brand-deep px-5 py-12 text-center text-white sm:py-16" data-id="element-130" data-mp="ijbdzngfp0gj">
          <div className="mx-auto max-w-3xl" data-id="element-131" data-mp="ehzn7eltq96r">
            <ZapIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-132" data-mp="ej18ebwk0c27" />
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-133" data-mp="1wea584gnvhrx">
              Stop improvising. Coach with a system.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-134" data-mp="265egou74oki0">
              You have 60 days to try this risk-free. If you do not see a dramatic improvement in your planning efficiency, your client results, and your professional positioning, we refund 100% of your investment. No questions asked.
            </p>
            <p className="mt-5 text-sm font-black text-brand-gold" data-id="element-135" data-mp="1igd2srfj0h5c">
              6 volumes + 5 bonuses · Today only for 27 USD
            </p>
            <CtaButton label="YES, I WANT THE SYSTEM!" className="mt-3" data-id="element-136" data-mp="1mji44qnvecse" />
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-137" data-mp="1rhjmtahdwa3c">
              Secure checkout in your local currency
            </p>
          </div>
        </section>

      </main>

      <footer className="bg-[#08090A] px-5 py-10 text-center text-white/70" data-id="element-138" data-mp="32tu7supvz1x8">
        <ShieldCheckIcon className="mx-auto h-6 w-6 text-brand-gold" aria-hidden="true" data-id="element-139" data-mp="2ejwlkrm7sam9" />
        <p className="mt-4 text-sm" data-id="element-140" data-mp="29kjq5iha1v82">© 2026 The Personal Trainer System</p>
        <nav aria-label="Footer navigation" className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-141" data-mp="2nawwjgeit1va">
          <a href="#privacy" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-142" data-mp="2ik6r6363gz0l">
            Privacy Policy
          </a>
          <a href="#terms" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-143" data-mp="2sb1df7jcbym1">
            Terms & Conditions
          </a>
          <a href="#contact" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-144" data-mp="329h81khktq0a">
            Contact
          </a>
        </nav>
        <p className="mx-auto mt-6 max-w-3xl text-xs leading-relaxed text-white/55" data-id="element-145" data-mp="17vpy0jvc544b">
          This product is an educational and informational resource for fitness professionals. It does not constitute medical, legal, or financial advice.
        </p>
      </footer>

    </div>;
}